// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { EntityType } from "./EntityType";
import {
  EntityTypeFromJSON,
  EntityTypeFromJSONTyped,
  EntityTypeToJSON,
  EntityTypeToJSONTyped,
} from "./EntityType";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";

/**
 *
 * @export
 * @interface EventRead
 */
export interface EventRead {
  /**
   *
   */
  id?: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  entityType: EntityType;
  /**
   *
   */
  entityId: string;
  /**
   * Filter by project
   */
  projectId: string | null;
  /**
   *
   */
  correlationId: string | null;
  /**
   *
   */
  data: { [key: string]: any };
  /**
   *
   */
  message: string;
  /**
   *
   */
  user: User | null;
}

/**
 * Check if a given object implements the EventRead interface.
 */
export function instanceOfEventRead(value: object): value is EventRead {
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("entityType" in (value as Record<string, any>)) &&
      !("entity_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["entityType"] === undefined &&
      (value as Record<string, any>)["entity_type"] === undefined)
  )
    return false;
  if (
    (!("entityId" in (value as Record<string, any>)) &&
      !("entity_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["entityId"] === undefined &&
      (value as Record<string, any>)["entity_id"] === undefined)
  )
    return false;
  if (
    (!("projectId" in (value as Record<string, any>)) &&
      !("project_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectId"] === undefined &&
      (value as Record<string, any>)["project_id"] === undefined)
  )
    return false;
  if (
    (!("correlationId" in (value as Record<string, any>)) &&
      !("correlation_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["correlationId"] === undefined &&
      (value as Record<string, any>)["correlation_id"] === undefined)
  )
    return false;
  if (!("data" in value) || value["data"] === undefined) return false;
  if (!("message" in value) || value["message"] === undefined) return false;
  if (!("user" in value) || value["user"] === undefined) return false;
  return true;
}

export function EventReadFromJSON(json: any): EventRead {
  return EventReadFromJSONTyped(json, false);
}

export function EventReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    entityType: EntityTypeFromJSON(json["entity_type"]),
    entityId: json["entity_id"],
    projectId: json["project_id"],
    correlationId: json["correlation_id"],
    data: json["data"],
    message: json["message"],
    user: UserFromJSON(json["user"]),
  };
}

export function EventReadToJSON(json: any): EventRead {
  return EventReadToJSONTyped(json, false);
}

export function EventReadToJSONTyped(
  value?: EventRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    entity_type: EntityTypeToJSON(value["entityType"]),
    entity_id: value["entityId"],
    project_id: value["projectId"],
    correlation_id: value["correlationId"],
    data: value["data"],
    message: value["message"],
    user: UserToJSON(value["user"]),
  };
}
